const integrations = {
  backToIntegrations: 'Integraciones',
  enabled: 'Habilitado',
  outOfService: 'Próximamente ...',
  enable: 'Habilitar',
  app: {
    actions: {
      disable: {
        button: 'Deshabilitar',
        success: 'La integración se deshabilitó correctamente',
        failure: 'Ocurrió un error al deshabilitar la integración',
        confirmModal: {
          header: 'Confirmar la desconexión de la integración',
          body: 'Para deshabilitar la integración, ingrese la palabra \'deshabilitar\' en el campo de texto y confirme.',
          verificationPhrase: 'deshabilitar',
        },
      },
      oneTwoWayVerificationModal: {
        toOneWayInstructions: 'Para cambiar la integración a unidireccional, ingresa la palabra \'cambiar\' en el campo de texto y confirma',
        toTwoWayInstructions: 'Para cambiar la integración a bidireccional, ingresa la palabra \'cambiar\' en el campo de texto y confirma.',
        verificationPhrase: 'cambiar',
      },
      submit: {
        success: 'Acción personalizada iniciada correctamente',
        failure: 'Ocurrió un error al iniciar la acción personalizada',
      },
    },
  },
  form: {
    submit: {
      enable: {
        success: 'La integración se activó correctamente. Se han iniciado acciones personalizadas ...',
        failure: 'No se pudo habilitar la integración. Compruebe su configuración de autenticación',
      },
    },
  },
};

export default integrations;
